export function getReturnOfExpression(expression) {
    return null;
}
export var returntypeof = getReturnOfExpression;
//# sourceMappingURL=returntypeof.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-typescript/es5-module/returntypeof.js
// module id = 1108
// module chunks = 0